export enum AnswerCode {
  No = 0,
  Yes = 1,
  Invalid = 2,
  // 3 é de uso interno do backend e nunca chega ao front.
  CorrectGuess = 4,
  WrongGuess = 5,
}
